
export default class VocConfig {

  constructor(allConf = []) {
    this.all = allConf;
    this.resetFilter();
  }

  get gscmDivisions() {
    // console.log('getter: gscmDivisions')
    let _gscmDivList = Array.from(new Set(this.all.map(x => x.group1))).filter(x => x !== "");
    return _gscmDivList.map(x => {
      return { code: x, name: x }
    })
  }

  get categories() {
    // console.log('getter: categories')
    let _g1;
    let _filteredConfList = [...this.all];

    // Filter by selected GSCM Divs
    if (this.filter.group1.length > 0) {
      _g1 = this.filter.group1.split('^');
      _filteredConfList = _filteredConfList.filter(o => _g1.some(f => f === o.group1))
    }

    let _categoryList = Array.from(new Set(_filteredConfList.map(x => x.group2))).filter(x => x !== "");
    return _categoryList.map(x => {
      return { code: x, name: x }
    })
  }

  get subcategories() {
    // console.log('getter: subcategories')
    let _g1;
    let _g2;
    let _filteredConfList = [...this.all];

    // Filter by selected GSCM Divs
    if (this.filter.group1.length > 0) {
      _g1 = this.filter.group1.split('^');
      _filteredConfList = _filteredConfList.filter(o => _g1.some(f => f === o.group1))
    }

    // Filter by selected Categories
    if (this.filter.group2.length > 0) {
      _g2 = this.filter.group2.split('^');
      _filteredConfList = _filteredConfList.filter(o => _g2.some(f => f === o.group2))
    }

    let _subcategoryList = Array.from(new Set(_filteredConfList.map(x => x.group3))).filter(x => x !== "");
    return _subcategoryList.map(x => {
      return { code: x, name: x }
    })
  }

  get items() {
    let _g1;
    let _g2;
    let _g3;
    let _filteredConfList = [...this.all];

    // Filter by selected GSCM Divs
    if (this.filter.group1.length > 0) {
      _g1 = this.filter.group1.split('^');
      _filteredConfList = _filteredConfList.filter(o => _g1.some(f => f === o.group1))
    }

    // Filter by selected Categories
    if (this.filter.group2.length > 0) {
      _g2 = this.filter.group2.split('^');
      _filteredConfList = _filteredConfList.filter(o => _g2.some(f => f === o.group2))
    }

    // Filter by selected Subcategories
    if (this.filter.group3.length > 0) {
      _g3 = this.filter.group3.split('^');
      _filteredConfList = _filteredConfList.filter(o => _g3.some(f => f === o.group3))
    }

    let _itemList = Array.from(new Set(_filteredConfList.map(x => x.group4))).filter(x => x !== "");
    return _itemList.map(x => {
      return { code: x, name: x }
    })
  }

  resetFilter() {
    this.filter = {
      group1: '',
      group2: '',
      group3: ''
    };
  }

}
